import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _00bf4bcc = () => interopDefault(import('../pages/aboutus.vue' /* webpackChunkName: "pages/aboutus" */))
const _332cb94e = () => interopDefault(import('../pages/cipp-offer/index.vue' /* webpackChunkName: "pages/cipp-offer/index" */))
const _120f76a2 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _755847ae = () => interopDefault(import('../pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _3b605898 = () => interopDefault(import('../pages/business/analytics.vue' /* webpackChunkName: "pages/business/analytics" */))
const _601297e8 = () => interopDefault(import('../pages/business/communication.vue' /* webpackChunkName: "pages/business/communication" */))
const _eaff56f2 = () => interopDefault(import('../pages/business/membersupport.vue' /* webpackChunkName: "pages/business/membersupport" */))
const _2abfba9a = () => interopDefault(import('../pages/dashboard/combine.vue' /* webpackChunkName: "pages/dashboard/combine" */))
const _00dc26a8 = () => interopDefault(import('../pages/dashboard/documents.vue' /* webpackChunkName: "pages/dashboard/documents" */))
const _2ec9338b = () => interopDefault(import('../pages/dashboard/landing.vue' /* webpackChunkName: "pages/dashboard/landing" */))
const _19cc97f0 = () => interopDefault(import('../pages/dashboard/nextsteps.vue' /* webpackChunkName: "pages/dashboard/nextsteps" */))
const _6b5967f0 = () => interopDefault(import('../pages/dashboard/report.vue' /* webpackChunkName: "pages/dashboard/report" */))
const _037f3733 = () => interopDefault(import('../pages/dashboard/reports.vue' /* webpackChunkName: "pages/dashboard/reports" */))
const _79f7d396 = () => interopDefault(import('../pages/dashboard/retirement.vue' /* webpackChunkName: "pages/dashboard/retirement" */))
const _1e26bbb9 = () => interopDefault(import('../pages/dashboard/review-choices.vue' /* webpackChunkName: "pages/dashboard/review-choices" */))
const _01055150 = () => interopDefault(import('../pages/dashboard/selected-funds.vue' /* webpackChunkName: "pages/dashboard/selected-funds" */))
const _022bae74 = () => interopDefault(import('../pages/dashboard/selfhelpdirectory.vue' /* webpackChunkName: "pages/dashboard/selfhelpdirectory" */))
const _3576c65f = () => interopDefault(import('../pages/dashboard/settings.vue' /* webpackChunkName: "pages/dashboard/settings" */))
const _78a7fd62 = () => interopDefault(import('../pages/dashboard/shortlist-funds.vue' /* webpackChunkName: "pages/dashboard/shortlist-funds" */))
const _a40e9610 = () => interopDefault(import('../pages/onboarding/annuity-options.vue' /* webpackChunkName: "pages/onboarding/annuity-options" */))
const _6ae79334 = () => interopDefault(import('../pages/onboarding/authorization.vue' /* webpackChunkName: "pages/onboarding/authorization" */))
const _971dd82e = () => interopDefault(import('../pages/onboarding/checkout.vue' /* webpackChunkName: "pages/onboarding/checkout" */))
const _17fcc5d8 = () => interopDefault(import('../pages/onboarding/confirmation.vue' /* webpackChunkName: "pages/onboarding/confirmation" */))
const _9a1500c8 = () => interopDefault(import('../pages/onboarding/employment-info.vue' /* webpackChunkName: "pages/onboarding/employment-info" */))
const _947e6c4a = () => interopDefault(import('../pages/onboarding/enhanced-quotes.vue' /* webpackChunkName: "pages/onboarding/enhanced-quotes" */))
const _5403c7e7 = () => interopDefault(import('../pages/onboarding/fund-selection.vue' /* webpackChunkName: "pages/onboarding/fund-selection" */))
const _06643ca7 = () => interopDefault(import('../pages/onboarding/future-pension.vue' /* webpackChunkName: "pages/onboarding/future-pension" */))
const _5150c0ae = () => interopDefault(import('../pages/onboarding/future-pot.vue' /* webpackChunkName: "pages/onboarding/future-pot" */))
const _45c2f256 = () => interopDefault(import('../pages/onboarding/login.vue' /* webpackChunkName: "pages/onboarding/login" */))
const _449d1c51 = () => interopDefault(import('../pages/onboarding/login-error.vue' /* webpackChunkName: "pages/onboarding/login-error" */))
const _740c08d7 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/index.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/index" */))
const _464f44d6 = () => interopDefault(import('../pages/onboarding/money-purchase-annual-allowance.vue' /* webpackChunkName: "pages/onboarding/money-purchase-annual-allowance" */))
const _396f64ad = () => interopDefault(import('../pages/onboarding/my-tax-liability.vue' /* webpackChunkName: "pages/onboarding/my-tax-liability" */))
const _109fd274 = () => interopDefault(import('../pages/onboarding/other-pot-addition.vue' /* webpackChunkName: "pages/onboarding/other-pot-addition" */))
const _00e58270 = () => interopDefault(import('../pages/onboarding/pension-details.vue' /* webpackChunkName: "pages/onboarding/pension-details" */))
const _118d6eb2 = () => interopDefault(import('../pages/onboarding/pension-provider-by-name.vue' /* webpackChunkName: "pages/onboarding/pension-provider-by-name" */))
const _50af6967 = () => interopDefault(import('../pages/onboarding/pension-savings.vue' /* webpackChunkName: "pages/onboarding/pension-savings" */))
const _a23e05f0 = () => interopDefault(import('../pages/onboarding/personal-info.vue' /* webpackChunkName: "pages/onboarding/personal-info" */))
const _d9eebed4 = () => interopDefault(import('../pages/onboarding/pot-usage.vue' /* webpackChunkName: "pages/onboarding/pot-usage" */))
const _6c342340 = () => interopDefault(import('../pages/onboarding/redeem-voucher.vue' /* webpackChunkName: "pages/onboarding/redeem-voucher" */))
const _91570b88 = () => interopDefault(import('../pages/onboarding/reset-password.vue' /* webpackChunkName: "pages/onboarding/reset-password" */))
const _f466f6a0 = () => interopDefault(import('../pages/onboarding/success.vue' /* webpackChunkName: "pages/onboarding/success" */))
const _39ea3d11 = () => interopDefault(import('../pages/onboarding/suez-info.vue' /* webpackChunkName: "pages/onboarding/suez-info" */))
const _659ddee7 = () => interopDefault(import('../pages/onboarding/tapered-allowance.vue' /* webpackChunkName: "pages/onboarding/tapered-allowance" */))
const _71715f76 = () => interopDefault(import('../pages/onboarding/tax-charge-period.vue' /* webpackChunkName: "pages/onboarding/tax-charge-period" */))
const _1552bef6 = () => interopDefault(import('../pages/onboarding/tax-payment-methods.vue' /* webpackChunkName: "pages/onboarding/tax-payment-methods" */))
const _f2e74e82 = () => interopDefault(import('../pages/personal/account.vue' /* webpackChunkName: "pages/personal/account" */))
const _4aa816b4 = () => interopDefault(import('../pages/personal/nextsteps.vue' /* webpackChunkName: "pages/personal/nextsteps" */))
const _648c2d52 = () => interopDefault(import('../pages/personal/retirement.vue' /* webpackChunkName: "pages/personal/retirement" */))
const _7bfe7451 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/index.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/index" */))
const _6b1cd73d = () => interopDefault(import('../pages/onboarding/medical-questionnaire/lifestyle/index.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/lifestyle/index" */))
const _1bc6b58c = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/index.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/index" */))
const _1f6563fa = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/bathing-and-showering.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/bathing-and-showering" */))
const _50751d53 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/bladder-control.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/bladder-control" */))
const _ffeee700 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/bowel-control.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/bowel-control" */))
const _af2b17c8 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/dressing.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/dressing" */))
const _bfcfab7a = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/feeding.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/feeding" */))
const _226734a2 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/mobility-indoors.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/mobility-indoors" */))
const _01d78813 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/progression-over-time.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/progression-over-time" */))
const _68e328e9 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/review.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/review" */))
const _d27fa428 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/ADL/transferring.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/ADL/transferring" */))
const _21ed3eb9 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/lifestyle/alcohol.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/lifestyle/alcohol" */))
const _3a86d393 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/lifestyle/general.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/lifestyle/general" */))
const _5d91237d = () => interopDefault(import('../pages/onboarding/medical-questionnaire/lifestyle/review.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/lifestyle/review" */))
const _14e6af17 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/lifestyle/smoking.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/lifestyle/smoking" */))
const _b7e31b94 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/cancer.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/cancer" */))
const _546f8cb9 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/diabetes.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/diabetes" */))
const _68325a22 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/general.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/general" */))
const _5ea490ce = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/high-cholesterol.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/high-cholesterol" */))
const _34864a9c = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/hypertension.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/hypertension" */))
const _1697d590 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/multiple-sclerosis.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/multiple-sclerosis" */))
const _595d2584 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/neurological.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/neurological" */))
const _7bb9e1e4 = () => interopDefault(import('../pages/onboarding/medical-questionnaire/medical-assessment/review.vue' /* webpackChunkName: "pages/onboarding/medical-questionnaire/medical-assessment/review" */))
const _69591504 = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _95ed637e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutus",
    component: _00bf4bcc,
    name: "aboutus"
  }, {
    path: "/cipp-offer",
    component: _332cb94e,
    name: "cipp-offer"
  }, {
    path: "/help",
    component: _120f76a2,
    name: "help"
  }, {
    path: "/verify-email",
    component: _755847ae,
    name: "verify-email"
  }, {
    path: "/business/analytics",
    component: _3b605898,
    name: "business-analytics"
  }, {
    path: "/business/communication",
    component: _601297e8,
    name: "business-communication"
  }, {
    path: "/business/membersupport",
    component: _eaff56f2,
    name: "business-membersupport"
  }, {
    path: "/dashboard/combine",
    component: _2abfba9a,
    name: "dashboard-combine"
  }, {
    path: "/dashboard/documents",
    component: _00dc26a8,
    name: "dashboard-documents"
  }, {
    path: "/dashboard/landing",
    component: _2ec9338b,
    name: "dashboard-landing"
  }, {
    path: "/dashboard/nextsteps",
    component: _19cc97f0,
    name: "dashboard-nextsteps"
  }, {
    path: "/dashboard/report",
    component: _6b5967f0,
    name: "dashboard-report"
  }, {
    path: "/dashboard/reports",
    component: _037f3733,
    name: "dashboard-reports"
  }, {
    path: "/dashboard/retirement",
    component: _79f7d396,
    name: "dashboard-retirement"
  }, {
    path: "/dashboard/review-choices",
    component: _1e26bbb9,
    name: "dashboard-review-choices"
  }, {
    path: "/dashboard/selected-funds",
    component: _01055150,
    name: "dashboard-selected-funds"
  }, {
    path: "/dashboard/selfhelpdirectory",
    component: _022bae74,
    name: "dashboard-selfhelpdirectory"
  }, {
    path: "/dashboard/settings",
    component: _3576c65f,
    name: "dashboard-settings"
  }, {
    path: "/dashboard/shortlist-funds",
    component: _78a7fd62,
    name: "dashboard-shortlist-funds"
  }, {
    path: "/onboarding/annuity-options",
    component: _a40e9610,
    name: "onboarding-annuity-options"
  }, {
    path: "/onboarding/authorization",
    component: _6ae79334,
    name: "onboarding-authorization"
  }, {
    path: "/onboarding/checkout",
    component: _971dd82e,
    name: "onboarding-checkout"
  }, {
    path: "/onboarding/confirmation",
    component: _17fcc5d8,
    name: "onboarding-confirmation"
  }, {
    path: "/onboarding/employment-info",
    component: _9a1500c8,
    name: "onboarding-employment-info"
  }, {
    path: "/onboarding/enhanced-quotes",
    component: _947e6c4a,
    name: "onboarding-enhanced-quotes"
  }, {
    path: "/onboarding/fund-selection",
    component: _5403c7e7,
    name: "onboarding-fund-selection"
  }, {
    path: "/onboarding/future-pension",
    component: _06643ca7,
    name: "onboarding-future-pension"
  }, {
    path: "/onboarding/future-pot",
    component: _5150c0ae,
    name: "onboarding-future-pot"
  }, {
    path: "/onboarding/login",
    component: _45c2f256,
    name: "onboarding-login"
  }, {
    path: "/onboarding/login-error",
    component: _449d1c51,
    name: "onboarding-login-error"
  }, {
    path: "/onboarding/medical-questionnaire",
    component: _740c08d7,
    name: "onboarding-medical-questionnaire"
  }, {
    path: "/onboarding/money-purchase-annual-allowance",
    component: _464f44d6,
    name: "onboarding-money-purchase-annual-allowance"
  }, {
    path: "/onboarding/my-tax-liability",
    component: _396f64ad,
    name: "onboarding-my-tax-liability"
  }, {
    path: "/onboarding/other-pot-addition",
    component: _109fd274,
    name: "onboarding-other-pot-addition"
  }, {
    path: "/onboarding/pension-details",
    component: _00e58270,
    name: "onboarding-pension-details"
  }, {
    path: "/onboarding/pension-provider-by-name",
    component: _118d6eb2,
    name: "onboarding-pension-provider-by-name"
  }, {
    path: "/onboarding/pension-savings",
    component: _50af6967,
    name: "onboarding-pension-savings"
  }, {
    path: "/onboarding/personal-info",
    component: _a23e05f0,
    name: "onboarding-personal-info"
  }, {
    path: "/onboarding/pot-usage",
    component: _d9eebed4,
    name: "onboarding-pot-usage"
  }, {
    path: "/onboarding/redeem-voucher",
    component: _6c342340,
    name: "onboarding-redeem-voucher"
  }, {
    path: "/onboarding/reset-password",
    component: _91570b88,
    name: "onboarding-reset-password"
  }, {
    path: "/onboarding/success",
    component: _f466f6a0,
    name: "onboarding-success"
  }, {
    path: "/onboarding/suez-info",
    component: _39ea3d11,
    name: "onboarding-suez-info"
  }, {
    path: "/onboarding/tapered-allowance",
    component: _659ddee7,
    name: "onboarding-tapered-allowance"
  }, {
    path: "/onboarding/tax-charge-period",
    component: _71715f76,
    name: "onboarding-tax-charge-period"
  }, {
    path: "/onboarding/tax-payment-methods",
    component: _1552bef6,
    name: "onboarding-tax-payment-methods"
  }, {
    path: "/personal/account",
    component: _f2e74e82,
    name: "personal-account"
  }, {
    path: "/personal/nextsteps",
    component: _4aa816b4,
    name: "personal-nextsteps"
  }, {
    path: "/personal/retirement",
    component: _648c2d52,
    name: "personal-retirement"
  }, {
    path: "/onboarding/medical-questionnaire/ADL",
    component: _7bfe7451,
    name: "onboarding-medical-questionnaire-ADL"
  }, {
    path: "/onboarding/medical-questionnaire/lifestyle",
    component: _6b1cd73d,
    name: "onboarding-medical-questionnaire-lifestyle"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment",
    component: _1bc6b58c,
    name: "onboarding-medical-questionnaire-medical-assessment"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/bathing-and-showering",
    component: _1f6563fa,
    name: "onboarding-medical-questionnaire-ADL-bathing-and-showering"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/bladder-control",
    component: _50751d53,
    name: "onboarding-medical-questionnaire-ADL-bladder-control"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/bowel-control",
    component: _ffeee700,
    name: "onboarding-medical-questionnaire-ADL-bowel-control"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/dressing",
    component: _af2b17c8,
    name: "onboarding-medical-questionnaire-ADL-dressing"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/feeding",
    component: _bfcfab7a,
    name: "onboarding-medical-questionnaire-ADL-feeding"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/mobility-indoors",
    component: _226734a2,
    name: "onboarding-medical-questionnaire-ADL-mobility-indoors"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/progression-over-time",
    component: _01d78813,
    name: "onboarding-medical-questionnaire-ADL-progression-over-time"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/review",
    component: _68e328e9,
    name: "onboarding-medical-questionnaire-ADL-review"
  }, {
    path: "/onboarding/medical-questionnaire/ADL/transferring",
    component: _d27fa428,
    name: "onboarding-medical-questionnaire-ADL-transferring"
  }, {
    path: "/onboarding/medical-questionnaire/lifestyle/alcohol",
    component: _21ed3eb9,
    name: "onboarding-medical-questionnaire-lifestyle-alcohol"
  }, {
    path: "/onboarding/medical-questionnaire/lifestyle/general",
    component: _3a86d393,
    name: "onboarding-medical-questionnaire-lifestyle-general"
  }, {
    path: "/onboarding/medical-questionnaire/lifestyle/review",
    component: _5d91237d,
    name: "onboarding-medical-questionnaire-lifestyle-review"
  }, {
    path: "/onboarding/medical-questionnaire/lifestyle/smoking",
    component: _14e6af17,
    name: "onboarding-medical-questionnaire-lifestyle-smoking"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/cancer",
    component: _b7e31b94,
    name: "onboarding-medical-questionnaire-medical-assessment-cancer"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/diabetes",
    component: _546f8cb9,
    name: "onboarding-medical-questionnaire-medical-assessment-diabetes"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/general",
    component: _68325a22,
    name: "onboarding-medical-questionnaire-medical-assessment-general"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/high-cholesterol",
    component: _5ea490ce,
    name: "onboarding-medical-questionnaire-medical-assessment-high-cholesterol"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/hypertension",
    component: _34864a9c,
    name: "onboarding-medical-questionnaire-medical-assessment-hypertension"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/multiple-sclerosis",
    component: _1697d590,
    name: "onboarding-medical-questionnaire-medical-assessment-multiple-sclerosis"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/neurological",
    component: _595d2584,
    name: "onboarding-medical-questionnaire-medical-assessment-neurological"
  }, {
    path: "/onboarding/medical-questionnaire/medical-assessment/review",
    component: _7bb9e1e4,
    name: "onboarding-medical-questionnaire-medical-assessment-review"
  }, {
    path: "/blog/:slug?",
    component: _69591504,
    name: "blog-slug"
  }, {
    path: "/",
    component: _95ed637e,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
